import { USER_EVENTS } from '@shared/core/user-events'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import { AlertCampaign } from '../alerts.types'

const EXCLUDED_SIGNUP_SOURCES = new Set(['shopify', 'wordpress'])

export const shopifyWordpressSurveyModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.SHOPIFY_WORDPRESS_SURVEY,
  priority: ALERT_CAMPAIGN_PRIORITIES.SHOPIFY_WORDPRESS_SURVEY,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.SHOPIFY_WORDPRESS_SURVEY],
  isEligible: (context) => {
    if (context.profile === null) {
      return false
    }

    if (context.profile.usage_mode !== 'customer') {
      return false
    }

    if (EXCLUDED_SIGNUP_SOURCES.has(context.profile.signup_source ?? '')) {
      return false
    }

    if (context.userEvents.has(USER_EVENTS.SHOPIFY_WORDPRESS_SURVEY_MODAL_SEEN)) {
      return false
    }

    return context.userEvents.has(USER_EVENTS.REVIEW_FIRST_EVENT_MODAL_SEEN)
  },
}
